import { UserAuth } from '../../context/AuthContext'

const SupportSessionBanner = () => {
  const { isSupportSession, endSupportSession } = UserAuth()

  if (!isSupportSession) return null

  return (
    <div className='fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-4 rounded-full bg-amber-400 px-5 py-2 text-sm font-semibold text-slate-900 shadow-lg'>
      <span>Modo soporte: estás viendo esta organización como observador</span>
      <button
        type='button'
        onClick={endSupportSession}
        className='rounded-md bg-slate-900 px-3 py-1 text-xs font-semibold text-white hover:bg-slate-700'
      >
        Salir
      </button>
    </div>
  )
}

export default SupportSessionBanner
